import React, { useContext, useEffect, useState } from "react";
import styles from "../BookModule/ViewBook/ViewBook.module.css";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { Rating } from "@mui/material";
import moment from "moment";
import toast from "react-hot-toast";
import { AxiosInstance } from "../../../../axios";

const BookReviewModal = ({
  open,
  setOpen,
  handleModelOpen,
  handleModelClose,
  selectedBookId,
  cancelLable,
  type,
}) => {
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;

  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("UserId Not available");
  }
  const [initialfields, setInitialfields] = useState({
    ratingStar: 0,
    rateBook: "",
    iframe: "",
  });
  const [error, setError] = useState({});

  const handleRating = (newValue) => {
    setInitialfields((prevFields) => ({
      ...prevFields,
      ["ratingStar"]: newValue,
    }));
    setError({
      ...error,
      ["ratingStar"]: "",
    });
  };

  const handleIframeChange = (e) => {
    let value = e.target.value;
    let errorMessage = "";

    // ✅ Always update the input value (even when empty)
    setInitialfields((prevFields) => ({
      ...prevFields,
      iframe: value,
    }));

    // ✅ If empty, clear the error and return early
    if (value.trim() === "") {
      setError((prev) => ({
        ...prev,
        iframe: "",
      }));
      return;
    }

    // ✅ Validate only when there's a value
    const youtubeRegex =
      /^(https?:\/\/(www\.)?youtube\.com\/(watch\?v=|shorts\/|embed\/)[a-zA-Z0-9_-]+(\?.*)?)$|^(https?:\/\/youtu\.be\/[a-zA-Z0-9_-]+(\?.*)?)$/;

    if (!youtubeRegex.test(value)) {
      errorMessage = "Please enter a valid YouTube URL";
    } else {
      const youtuMatch = value.match(
        /^https?:\/\/youtu\.be\/([a-zA-Z0-9_-]+)(\?.*)?$/
      );
      if (youtuMatch) {
        value = `https://www.youtube.com/embed/${youtuMatch[1]}`;
        // ✅ Update with embed URL if valid
        setInitialfields((prevFields) => ({
          ...prevFields,
          iframe: value,
        }));
      }
    }

    // ✅ Update the error message (empty string if valid)
    setError((prev) => ({
      ...prev,
      iframe: errorMessage,
    }));
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setInitialfields((prevFields) => ({
      ...prevFields,
      [name]: value,
    }));
    setError({
      ...error,
      [name]: "",
    });
  };

  const validateERRORDEFields = (datas) => {
    console.log(datas, "datas0000000000000");

    const errors = {};
    if (datas.ratingStar == "" || !datas.ratingStar) {
      errors.ratingStar = "Please give rating ";
    }
    if (!datas.rateBook || datas.rateBook?.trim() === "") {
      errors.rateBook = "Please fill the review comments";
    }

    return errors;
  };
  const cleanIframeUrl = (iframeString) => {
    if (!iframeString) return "";
    const match = iframeString.match(/src="([^"]*)"/);
    return match ? match[1] : iframeString;
  };
  const handleMSReview = () => {
    const errors = validateERRORDEFields(initialfields);
    if (initialfields.iframe.trim()) {
      const youtubeRegex =
        /^(https?:\/\/(www\.)?youtube\.com\/(watch\?v=|shorts\/|embed\/)[a-zA-Z0-9_-]+(\?.*)?)$|^(https?:\/\/youtu\.be\/[a-zA-Z0-9_-]+(\?.*)?)$/;

      if (
        initialfields.iframe.trim() === "<iframe></iframe>" ||
        !youtubeRegex.test(initialfields.iframe)
      ) {
        errors.iframe = "Invalid YouTube URL";
      }
    }
    if (Object.keys(errors).length === 0) {
      const assignratingStar = {
        id: "",
        book_id: parseInt(selectedBookId),
        rating: initialfields.ratingStar,
        review: initialfields.rateBook,
        video_path: initialfields.iframe.trim()
          ? cleanIframeUrl(initialfields.iframe)
          : "",
        created_dt: moment.utc(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        created_by: userid,
      };
      AxiosInstance.post("/api/book/addReview", assignratingStar)
        .then((res) => {
          if (res.data.status) {
            toast.success(res.data.message);
            handleModelClose();
          } else {
            toast.error(res.data.message);
            handleModelClose();
          }
        })
        .catch((error) => {
          return error;
        });
    } else {
      setError(errors);
    }
  };

  return (
    <Modal
      key={`modal-0-${0}`}
      show={open}
      onHide={handleModelClose}
      size="xl"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h5
            className={`${styles.view_title} fw-bold mb-0`}
            id="exampleModalLabel"
          >
            Add Rating and Review
          </h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <></>
        <div className="row global_container">
          <div className="col-12">
            <form className="row ">
              <div class="col-md-6">
                <label for="ratingStar" class="form-label confirm_value ">
                  Rate this book
                </label>
                <div>
                  <Rating
                    name="ratingStar"
                    value={initialfields.ratingStar} // Use the rating state to control the selected stars
                    onChange={(event, newValue) => handleRating(newValue)} // Update the state on change
                    sx={{
                      "& .MuiRating-iconFilled": {
                        color: "#c0272d", // Set filled icon color
                      },
                      "& .MuiRating-iconHover": {
                        color: "#c0272d", // Set hover color
                      },
                      margin: 0,
                    }}
                  />
                </div>
                {error.ratingStar && (
                  <small className="error_message">{error.ratingStar}</small>
                )}
              </div>

              <div class="col-md-6">
                <label for="iframe" class="form-label confirm_value ">
                  Review our book (YouTube Video URL)
                </label>

                <input
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  type="text"
                  id="iframe"
                  name="iframe"
                  placeholder="Enter YouTube video URL"
                  value={initialfields.iframe || ""}
                  onChange={handleIframeChange}
                />
                {error.iframe && (
                  <small className="error_message">{error.iframe}</small>
                )}
              </div>
              <div className="col-md-12">
                <label for="rateBook" class="form-label confirm_value ">
                  Review this book
                </label>
                <textarea
                  // ref={subject_ref}
                  className={`${styles.desc_input} w-100 rounded p-2 input-font-size`}
                  placeholder="Enter the review"
                  id="rateBook"
                  onChange={(e) => handleChange(e)}
                  value={initialfields.rateBook}
                  name="rateBook"
                  // maxLength={500}
                  style={{
                    height: "auto",
                    resize: "none",
                    // minHeight: "calc(24px * 8)",
                  }}
                ></textarea>
                {error.rateBook && (
                  <small className="error_message">{error.rateBook}</small>
                )}
              </div>
            </form>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {type == 1 ? (
          <ul className="List-Button">
            <li className="ListBtnItems">
              <button
                style={{ border: "none", background: "none" }}
                onClick={handleModelClose}
                className="secondaryButton"
              >
                Back to {cancelLable}
              </button>
            </li>
            <li className="ListBtnItems">
              <button
                style={{ border: "none" }}
                onClick={handleMSReview}
                className="primaryButton"
              >
                Submit Rating & Review
              </button>
            </li>
          </ul>
        ) : (
          <ul className="List-Button">
            <li className="ListBtnItems">
              <Link onClick={handleModelClose} className="secondaryButton">
                Back to {cancelLable}
              </Link>
            </li>
            <li className="ListBtnItems">
              <Link onClick={handleMSReview} className="primaryButton">
                Submit Rating & Review
              </Link>
            </li>
          </ul>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default BookReviewModal;
